import { render } from "./WhatIfAnalysis.vue?vue&type=template&id=7fb6e5c8&scoped=true"
import script from "./WhatIfAnalysis.vue?vue&type=script&lang=js"
export * from "./WhatIfAnalysis.vue?vue&type=script&lang=js"

import "./WhatIfAnalysis.vue?vue&type=style&index=0&id=7fb6e5c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fb6e5c8"]])

export default __exports__